require('bootstrap')
window.$ = window.jQuery = require('jquery')

$(function() {
  $(this).on('click', '.contact-modal', function() {
    let nid = $(this).data('nid')
    $('.contact-member-nid').val(nid);
    $('#contact-modal').modal('show')
  });
});